import { PrimariaApi } from "@uxland/primary-shell";
import { bootstrapActivityHistoryItem, teardownActivityHistoryItem } from "./activity-history-item/bootstrapper";
import { registerViews, unregisterViews } from "./handle-views";
import { bindDeps, unbindDeps } from "./infrastructure/ioc/container";
import { initializeLocalization } from "./localization";
import { setShellApiForOwnSpec } from "./activity-history-item/domain/specs/own-spec";

const bootstrapFeatures = (api: PrimariaApi) => {
  bootstrapActivityHistoryItem(api);
};

const teardownFeatures = () => {
  teardownActivityHistoryItem();
};

export const initialize = async (api: PrimariaApi) => {
  // Initialize the shellApi for OwnSpec to avoid circular dependencies
  setShellApiForOwnSpec(api);
  
  registerViews(api);
  await initializeLocalization(api);
  bindDeps(api);
  bootstrapFeatures(api);
  return Promise.resolve();
};

export const dispose = () => {
  // Clean up the shellApi reference
  setShellApiForOwnSpec(null);
  
  teardownFeatures();
  unregisterViews();
  unbindDeps();
  return Promise.resolve();
};
